import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * SMTP Send Email v1 Configuration Validator
 * Validates SMTP email configuration including connection, recipients, and content
 */
export const Smtp_Send_Email_1_ConfigValidator = z.object({
    smtpConnection: requiredString('SMTP Connection is required'),
    emailFrom: requiredString('From Email is required'),
    emailTo: requiredString('To Email is required'),
    emailCc: z.string().optional(),
    emailSubject: requiredString('Email Subject is required'),
    emailBody: requiredString('Email Body is required')
});
//# sourceMappingURL=smtp-send-email-1.js.map